import { Form } from "antd";
import i18n from "i18next";
import type { FC } from "react";

import type { CampaignEntity } from "src/app/features/Campaign/types/CampaignEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { campaignStateSelectorConfig, campaignTypeSelectorConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const CampaignsSearchForm: FC<SearchFormProps<CampaignEntity>> = ({ searchCallback }) => {
    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={i18n.t("form.system.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
            <Form.Item label={i18n.t("form.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item label={i18n.t("form.type")} name="type">
                <SelectDynamic name="type" label={i18n.t("form.type")} fieldConfig={campaignTypeSelectorConfig} />
            </Form.Item>
            <Form.Item label={i18n.t("form.state")} name="state">
                <SelectDynamic name="state" label={i18n.t("form.state")} fieldConfig={campaignStateSelectorConfig} />
            </Form.Item>
            <Form.Item label={i18n.t("campaignSearchForm.termId")} name="terminalId">
                <TextInput name="terminalId" />
            </Form.Item>
            <Form.Item label={i18n.t("form.serialNumber")} name="serialNumber">
                <TextInput name="serialNumber" />
            </Form.Item>
        </SearchForm>
    );
};
